
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = "कृषि विज्ञान - किसानों के लिए आधुनिक तकनीक", 
  description = "किसानों के लिए उन्नत कृषि तकनीक, सरकारी योजनाएं और कृषि उत्पादों की जानकारी", 
  keywords = "कृषि, खेती, किसान, बीज, उर्वरक, कृषि यंत्र", 
  ogImage = "/default-og-image.jpg",
  url = window.location.href
}) => {
  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;